import {Routes} from "@angular/router";
import {AuthenticationGuard, AuthorizationGuard} from "@softline/auth";
import {SOFTLINE_PERMISSION_LLR_KOMMISSIONIERUNG} from "./kommissionierung.shared";
import {RemoteConfigResolver} from "@softline/application";
import { LeaveArtikelAuswahlGuard } from './guards/leave-artikel-auswahl.guard';
import { LeaveBestellungenGuard } from './guards/leave-bestellungen.guard';

export const kommissionierungRoutes: Routes = [
  {
    path: 'llr-bskomm',
    loadComponent: () => import('./pages/kommissionierung.component').then(c => c.KommissionierungComponent),
    children: [
      {
        path: 'bestellungen',
        loadComponent: () => import('./pages/bestellungen/bestellungen.component').then(c => c.BestellungenComponent),
        canDeactivate: [LeaveBestellungenGuard],
      },
      {
        path: 'artikelauswahl',
        loadComponent: () => import('./pages/artikelauswahl/artikel-auswahl.component').then(c => c.ArtikelAuswahlComponent),
        canDeactivate: [LeaveArtikelAuswahlGuard],
      },
      {
        path: 'bewegung',
        data: {
          stepIndex: 0
        },
        loadComponent: () => import('./pages/bewegung/bewegung.component').then(c => c.BewegungComponent),
        children: [
          {
            path: ':id/palettenart-auswahl',
            data: {
              stepIndex: 1
            },
            loadComponent: () => import('./pages/bewegung/palettenart-auswahl/palettenart-auswahl.component').then(c => c.PalettenartAuswahlComponent),
          },
          {
            path: ':id/palettenauswahl',
            data: {
              stepIndex: 2
            },
            loadComponent: () => import('./pages/bewegung/palettenauswahl/paletten-auswahl.component').then(c => c.PalettenAuswahlComponent)
          },
          {
            path: ':id/artikeldaten-erfassung',
            data: {
              stepIndex: 3
            },
            loadComponent: () => import('./pages/bewegung/artikeldaten-erfassung/artikeldaten-erfassung.component').then(c => c.ArtikeldatenErfassungComponent),
            children: [
              {
                path: '',
                data: {
                  stepIndex: 3
                },
                loadComponent: () => import('./pages/bewegung/artikeldaten-erfassung/offene-menge-erfassung/offene-menge-erfassung.component').then(c => c.OffeneMengeErfassungComponent)
              },
              {
                path: ':id/mhd-charge-erfassung',
                data: {
                  stepIndex: 4
                },
                loadComponent: () => import('./pages/bewegung/artikeldaten-erfassung/mhd-charge-erfassung/mhd-charge-erfassung.component').then(c => c.MhdChargeErfassungComponent)
              }
            ]
          },
          {
            path: ':id/emballagen-erfassung',
            data: {
              stepIndex: 5
            },
            loadComponent: () => import('./pages/bewegung/emballagen-erfassung/emballagen-erfassung.component').then(c => c.EmballagenErfassungComponent)
          },
        ]
      },
      {
        path: 'warenzugang-abschliessen',
        data: {
          stepIndex: 6
        },
        loadComponent: () => import('./pages/warenzugang-abschliessen/warenzugang-abschliessen.component').then(c => c.WarenzugangAbschliessenComponent)
      }
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_LLR_KOMMISSIONIERUNG },
    resolve: {
      config: RemoteConfigResolver,
    }
  }
];
